import Debug from 'debug'
import { observer } from 'mobx-react-lite'
import { Trans } from '@lingui/react/macro'

const debug = Debug('jotta:NoFilesResults')

export const NoFilesResults: React.FC = observer(() => {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex h-full w-full flex-col items-center justify-start pt-24 text-center"
    >
      <h2 className="m-0 pb-6 pt-8 text-xl font-normal leading-8 text-grey3">
        <Trans>No matches for your search.</Trans>
      </h2>

      <p className="m-0 text-center text-base font-normal leading-6 text-grey4">
        <Trans>Check spelling or try a different keyword.</Trans>
      </p>
    </div>
  )
})
